export function relativeTime(intl, date, options = {
    numeric: 'auto',
    style: 'long',
}, cutoffMs = 1000 * 60 * 60 * 24) {
    if (!date) {
        return '';
    }
    const dt = new Date(date);
    if (isNaN(dt.getTime())) {
        return '';
    }
    // This is to prevent clock skew between the server and the client
    // so things don't appear like -1s ago.
    const diff = dt.getTime() - Date.now();
    const absDiff = Math.abs(diff);
    // If this is too new, return an empty string
    if (absDiff <= 1000) {
        return '';
    }
    if (absDiff < 1000 * 60) {
        return intl.formatRelativeTime(Math.round(diff / 1000), 'second', options);
    }
    if (absDiff < 1000 * 60 * 60) {
        return intl.formatRelativeTime(Math.round(diff / (1000 * 60)), 'minute', options);
    }
    if (absDiff < cutoffMs && absDiff < 1000 * 60 * 60 * 24) {
        return intl.formatRelativeTime(Math.round(diff / (1000 * 60 * 60)), 'hour', options);
    }
    if (absDiff < cutoffMs && absDiff >= 1000 * 60 * 60 * 24) {
        return intl.formatRelativeTime(Math.round(diff / (1000 * 60 * 60 * 24)), 'day', options);
    }
    return intl.formatDate(dt, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}
//# sourceMappingURL=relativeTime.js.map